<template>
  <div class="app-container">
    <!-- 主要内容区域 -->

    <div class="main-content">
      <div class="bgk-img" :class="{ 'is-fallback': bannerLoadFailed }">
        <img
          v-if="!bannerLoadFailed"
          src="https://www.hketang.cn/_nuxt/img/course-banner.2811f9b.png"
          alt="师资团队"
          @error="handleBannerError"
        />
        <div v-else class="banner-fallback">
          <div class="banner-content">
            <div class="banner-title">师资团队</div>
            <div class="banner-subtitle">资深名师，助你提升</div>
          </div>
        </div>
      </div>

      <div class="tabs-box">
        <div class="title-box">师资团队</div>

        <div class="listbox">
          <div class="ul-item">
            <div
              class="li-item"
              v-for="(item, index) in teamlist"
              :key="index"
              :class="{ 'touch-active': activeTeacherIndex === index }"
              @click="toggleTeacherIntro(index)"
            >
              <img :src="item.avatar" alt="" class="team-img" />

              <div class="info">
                <div class="name">{{ item.name }}</div>

                <div class="introduce">{{ item.introInfo }}</div>
              </div>

              <div class="absolute">
                <div class="absolutename">{{ item.name }}</div>

                <div class="absolutetitle">讲师介绍</div>

                <div class="absoluteInfo">
                  {{ item.introDetail }}
                </div>
              </div>
            </div>
          </div>

          <div class="block">
            <el-pagination
              style="text-align: right"
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pagesize"
              :current-page="currentPage"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getteachers } from "@/api/index.js";
export default {
  name: "team",
  components: {},
  data() {
    return {
      bannerLoadFailed: false,
      teamlist: [],
      currentPage: 1,
      pagesize: 12,
      total: 0,
      activeTeacherIndex: -1,
    };
  },
  created() {
    this.getteachers();
  },
  methods: {
    handleBannerError() {
      this.bannerLoadFailed = true;
    },
    toggleTeacherIntro(index) {
      // 移动端点按切换介绍；桌面端仍依赖 hover
      if (window.innerWidth > 992) return;
      this.activeTeacherIndex = this.activeTeacherIndex === index ? -1 : index;
    },
    getteachers() {
      getteachers({
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        // homePageViewd: true  // 只获取首页展示的教师
      }).then((res) => {
        if (res.data && res.data.list) {
          this.teamlist = res.data.list;
          this.total = res.data.total || 0;
          this.activeTeacherIndex = -1;
        } else {
          this.teamlist = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取教师信息失败:', error);
        this.teamlist = [];
        this.total = 0;
      }); 
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1; // 改变页面大小时重置页码
      this.getteachers(); 
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getteachers(); 
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  clear: both;
  .main-content {
    overflow: visible;
    position: relative;
    background: #f5f6f9;
    .bgk-img {
      width: 100%;
      height: 210px;
      z-index: 2;
      position: relative;
      background: linear-gradient(135deg, #eef4ff 0%, #f9fbff 55%, #e6eefc 100%);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.is-fallback {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .banner-fallback {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 20px;
        gap: 24px;
      }
      .banner-content {
        text-align: left;
      }
      .banner-title {
        font-size: 34px;
        line-height: 1.2;
        color: #2d3341;
        font-weight: 700;
      }
      .banner-subtitle {
        margin-top: 10px;
        font-size: 16px;
        color: #6b7280;
      }
    }
    .tabs-box {
      width: 100%;
      padding: 0 0 60px 0;
      position: relative;
      z-index: 10;
      overflow: visible;
      .title-box {
        background: #fff;
        border-radius: 20px 20px 0 0;
        width: 1200px;
        box-sizing: border-box;
        font-size: 24px;
        color: #2d3341;
        font-weight: 700;
        font-family: "Microsoft YaHei";
        margin: -30px auto 0;
        padding: 30px 30px 10px;
        position: relative;
        z-index: 3;
        text-align: left;
      }
      .listbox {
        width: 1200px;
        box-sizing: border-box;
        margin: 0 auto;
        background: #fff;
        padding: 0 30px 40px;
        border-radius: 0 0 20px 20px;
        .ul-item {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 20px;
          cursor: pointer;
          margin-top: 20px;
          .li-item {
            overflow: hidden;
            width: 100%;
            height: 345px;
            margin: 0;
            background-color: #fff;
            color: #fff;
            text-align: center;
            border-radius: 10px;
            position: relative;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
            transition: all 0.3s ease;
            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
            }
            img {
              width: 100%;
              height: 345px;
              object-fit: cover;
            }
            .info {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 80px;
              background-color: #fff;
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding: 0;
              box-sizing: border-box;
              transition: transform 0.3s ease-in-out;
              .name {
                color: #000;
                font-size: 20px;
                font-weight: 600;
                line-height: 1.2;
              }
              .introduce {
                color: #ed8a42;
                font-size: 14px;
                margin-top: 8px;
                padding: 0 15px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            &:hover .info {
              transform: translateY(100%);
            }
            .absolute {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              padding: 30px 20px;
              box-sizing: border-box;
              text-align: left;
              background-color: rgba(0, 0, 0, 0.6);
              font-family: Microsoft YaHei;
              .absolutename {
                color: #fff;
                font-size: 22px;
                font-weight: 700;
              }
              .absolutetitle {
                color: #fff;
                font-size: 16px;
                margin: 20px 0 10px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                padding-bottom: 8px;
              }
              .absoluteInfo {
                color: #fff;
                font-size: 14px;
                line-height: 1.6;
                height: 180px;
                overflow-y: auto;
              }
              /* 自定义滚动条样式 */
              .absoluteInfo::-webkit-scrollbar {
                width: 4px;
              }
              .absoluteInfo::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.5);
                border-radius: 4px;
              }
            }
            &:hover .absolute {
              display: block;
            }
          }
        }
        .block {
          margin-top: 40px;
          padding-bottom: 10px;
          :deep(.el-pagination.is-background .el-pager li:not(.disabled).active ){
            background-color: #d5182f;
            color: #FFF;
          }
          :deep(.el-pagination.is-background .el-pager li:hover ){
            color: #d5182f;
          }
        }
      }
    }
  }
}

/* ====== Mobile responsive overrides for Team page ====== */
@media (max-width: 1200px) {
  .app-container .main-content .bgk-img .banner-fallback {
    width: auto;
    padding: 0 16px;
  }
  .app-container .main-content .tabs-box .title-box {
    width: auto;
    margin: 0 16px;
    margin-top: -30px;
    padding: 24px 16px 10px;
    font-size: 20px;
  }
  .app-container .main-content .tabs-box .listbox {
    width: auto;
    margin: 0 16px;
    padding: 16px;
  }
}

@media (max-width: 992px) {
  .app-container .main-content .bgk-img {
    height: auto;
    min-height: 140px;
  }
  .app-container .main-content .bgk-img .banner-fallback {
    flex-direction: column;
    text-align: center;
    padding: 24px 16px;
    gap: 12px;
  }
  .app-container .main-content .bgk-img .banner-content {
    text-align: center;
  }
  .app-container .main-content .bgk-img .banner-title {
    font-size: 26px;
  }
  .app-container .main-content .tabs-box .listbox .ul-item {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .app-container .main-content .tabs-box .listbox .ul-item .li-item {
    height: auto;
    aspect-ratio: 3 / 4;
  }
  .app-container .main-content .tabs-box .listbox .ul-item .li-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .app-container .main-content .tabs-box .listbox .ul-item .li-item .info {
    height: 64px;

    .name {
      font-size: 16px;
    }
  }
  /* 触屏无 hover：默认显示底部信息，点按显示详情 */
  .app-container .main-content .tabs-box .listbox .ul-item .li-item:active .absolute,
  .app-container .main-content .tabs-box .listbox .ul-item .li-item.touch-active .absolute {
    display: block;
  }
  .app-container .main-content .tabs-box .listbox .ul-item .li-item:active .info,
  .app-container .main-content .tabs-box .listbox .ul-item .li-item.touch-active .info {
    transform: translateY(100%);
  }
  .app-container .main-content .tabs-box .block {
    overflow-x: auto;
  }
}

@media (max-width: 600px) {
  .app-container .main-content .bgk-img .banner-title {
    font-size: 22px;
  }
  .app-container .main-content .bgk-img .banner-subtitle {
    font-size: 13px;
  }
  .app-container .main-content .tabs-box .title-box {
    margin-top: -20px;
    font-size: 18px;
  }
  .app-container .main-content .tabs-box .listbox .ul-item {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
}
</style>
